import React from 'react';
import styled from 'styled-components';
import SupportColumnInfo from './component/supports/SupportColumnInfo';
import SupportList from './component/supports/SupportList';
import PageAboutSupport from './component/supports/PageAboutSupport';

const AdminSupports: React.FC = () => {
  return (
    <>
      <SupportContainer>
        <SupportColumnInfo />
        <SupportList />
        <PageAboutSupport />
      </SupportContainer>
    </>
  );
};

export default AdminSupports;

const SupportContainer = styled.main`
  width: 96%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: calc(8vh);
  margin-bottom: 5.8vh ;
  overflow: hidden;
`;
